<!-- eslint-disable -->
<template lang="pug">
    modal-frame(:display-modal='displayModal' @close="$emit('close')" @open="$emit('open')")
        div(slot='body')
            .header {{ $i18n.t('detective.detective_letters_header') }}
            .letters__box
                span.letter__box(
                    v-for='(letter, index) in letters',
                    v-html='lettersHTML[index]',
                    @click="$emit('playDialog', letter)"
                )
</template>

<script>
    /*eslint-disable*/
    import ModalFrame from '../../../modals/detective/ModalFrame.vue'

    export default {
        props: {
            displayModal: Boolean,
            letters: Array,
        },
        data() {
            return {
                lettersHTML: [
                    'О', 'М', 'И', 'Р', 'Р', 'А', 'И', 'Т'
                ],
            }
        },
        components: {
            ModalFrame
        }
    }
</script>

<style scoped lang="scss">
    .header {
        font-size: 18px;
    }

    .letters__box {
        text-align: center;
        padding: 30px 0;
        font-size: 50px;
        color: rgb(152, 113, 75);
    }

    .letter__box {
        cursor: pointer;
        margin-right: 10px;
        padding: 10px;
        border: solid 1px black;
        border-radius: 5px;
        &:last-child {
            margin-right: 0;
        }
    }
</style>
